import { type InstallationId, type TimestampUTC } from '@common/types/brandedTypes';

export interface ExportRequest {
  installationId: InstallationId;
  registerIndexes: number[];
  periodStartUtc: TimestampUTC;
  periodEndUtc: TimestampUTC;
  exportFileRowLimit: number;
}

export interface DataManagementExportRequest {
  installationId: InstallationId;
  periodStartUtc: TimestampUTC;
  periodEndUtc: TimestampUTC;
  exportFileRowLimit: number;
}

export enum ExportStatus {
  InProgress = 10,
  Completed = 20,
}

export interface Download {
  filename: string;
  content: Blob;
}

export interface DataManagementExportResponse {
  id: string;
}

export interface ExportStatusResponse {
  status: ExportStatus;
}
